import styled from "styled-components";

export const WidgetDraggableHolder = styled.div<{ hidden?: boolean }>`
    opacity: 0;
    position: absolute;
    left: calc(50% - 18px / 2);
    top: 4px;
`;
